import Box from '@mui/material/Box';
import { useEffect } from 'react';
import { VideoTranscript } from '../../types/videoTranscript';

declare global {
  interface Window {
    pixelsShortsAutoplay: (params: Record<string, any>) => void;
  }
}

const assets = [
  `https://pixels-js${process.env.REACT_APP_STAGE === 'prod' ? '' : '-dev'}.pixels.ai/vertical-player.main.js`,
  `https://pixels-js${process.env.REACT_APP_STAGE === 'prod' ? '' : '-dev'}.pixels.ai/vertical-player.main.css`,
  `https://shorts${process.env.REACT_APP_STAGE === 'prod' ? '' : '-dev'}.pixels.ai/build/pixels-no-ads/shorts-autoplay-slim-dashboard-preview.css`,
  `https://shorts${process.env.REACT_APP_STAGE === 'prod' ? '' : '-dev'}.pixels.ai/build/pixels-no-ads/shorts-autoplay-slim-dashboard-preview.js`
];

type ShortVideoProp = {
  headline: string,
  media: string,
  duration: number,
  transcript?: VideoTranscript
}

export const ShortVideo = ({ headline, duration, media, transcript }: ShortVideoProp) => {

  useEffect(() => {
    const loadScript = (src: string): Promise<void> => {
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    };

    const loadStylesheet = (href: string): Promise<void> => {
      return new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve();
        document.head.appendChild(link);
      });
    };

    Promise.all(
      assets.map(asset =>
        asset.endsWith('.js')
          ? loadScript(asset)
          : loadStylesheet(asset)
      )
    ).then(() => {
      window.pixelsShortsAutoplay({
        el: document.getElementById('shortVideo'),
        url: 'https://pixels.ai',
        sspName: '',
        player: 'pixels-no-ads',
        organisation: 'pixels',
        videos: [{
          headline,
          duration,
          'media_id': media,
          transcript_items: transcript?.items || [],
          transcript_audio_segments: transcript?.audio_segments || [],
          'animated_preview': undefined,
          'thumbnail': undefined,
          'organisation_name': 'Pixels.AI',
          'rh_logo_url': undefined,
          'format': 'vertical',
          'rightsholder': 'pixels',
          'contextual': false,
          'url_click_through': null,
          'prefer_captions': null,
          'is_popular': false,
          'is_shuffled': false,
          'short_player_title_override': null,
          'ad_break_type': null,
          'ad_break_skippable': false,
          'skip_custom_caption': false,
        }]
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcript]);

  return <Box id={'shortVideo'} sx={{
    height: 600,
    width: 300
  }}>
  </Box>;
};